export const SET_IS_START_INBOUND_WAREHOUSE = "SET_IS_START_INBOUND_WAREHOUSE";
export const SET_IS_FAILED_INBOUND_WAREHOUSE = "SET_IS_FAILED_INBOUND_WAREHOUSE";
export const SET_IS_SUCCESS_INBOUND_WAREHOUSE = "SET_IS_SUCCESS_INBOUND_WAREHOUSE";
export const SET_IS_NEED_TO_RELOAD_INBOUND_WAREHOUSE = "SET_IS_NEED_TO_RELOAD_INBOUND_WAREHOUSE";
export const SET_PAGINATION_DATA_INBOUND_WAREHOUSE = "SET_PAGINATION_DATA_INBOUND_WAREHOUSE";
//export const SET_DETAIL_DATA_INBOUND_WAREHOUSE = "SET_DETAIL_DATA_INBOUND_WAREHOUSE";
//export const SET_STATUS_DETAIL_DATA_INBOUND_WAREHOUSE = "SET_STATUS_DETAIL_DATA_INBOUND_WAREHOUSE";
//export const SET_LIST_OF_HUB_INBOUND_WAREHOUSE = "SET_LIST_OF_HUB_INBOUND_WAREHOUSE";